import { angularServicesNames } from "@topline/services/angularServicesNames";

(function (module) {
    module.service("internationaMarketFileService", [
        "$http",
        "$q",
        "Upload",
        "toastr",
        "toasterService",
        angularServicesNames.$uibModal,
        function (
            this: $TSFixMe,
            $http: ng.IHttpService,
            $q: ng.IQService,
            Upload: $TSFixMe,
            toastr: ng.toastr.IToastrService,
            toasterService: $TSFixMe,
            $uibModal: ng.ui.bootstrap.IModalService
        ) {
            var service = this;

            service.uploadSkuFile = async (data: $TSFixMe) => {
                const toast = toasterService.showReportGeneratingToast("FILE_IMPORTING");

                const markets = data.markets ? JSON.stringify(data.markets) : "";
                const historicalDataStart = data.historicalDataStart;
                const historicalDataEnd  = data.historicalDataEnd;

                const { data: validations } = await Upload.upload({
                    url: "api/market/file/sku-volume/validate",
                    data: { file: data.file, markets, historicalDataStart, historicalDataEnd }
                });

                const hasErrors = Object.values(validations).filter((r: $TSFixMe) => r.hasErrors).length > 0;

                if (hasErrors) {
                    toastr.clear(toast);
                    displayError(validations);
                    return Promise.reject();
                } else {
                    await Upload.upload({
                        url: "api/market/file/sku-volume",
                        data: { file: data.file, markets, historicalDataStart, historicalDataEnd }
                    });

                    toastr.clear(toast);
                    toasterService.success("FILE_IMPORTED");
                    return 'ok';
                }
            };

            service.uploadMarketFile = async (data: $TSFixMe) => {
                const toast = toasterService.showReportGeneratingToast("FILE_IMPORTING");

                const historicalDataStart = data.historicalDataStart;
                const historicalDataEnd  = data.historicalDataEnd;

                const { data: validations } = await Upload.upload({
                    url: "api/market/file/market-volume/validate",
                    data: { file: data.file, historicalDataStart, historicalDataEnd }
                });

                const hasErrors = Object.values(validations).filter((r: $TSFixMe) => r.hasErrors).length > 0;

                if (hasErrors) {
                    toastr.clear(toast);
                    displayError(validations);
                    return Promise.reject();
                } else {
                    await Upload.upload({
                        url: "api/market/file/market-volume",
                        data: { file: data.file, historicalDataStart, historicalDataEnd }
                    });

                    toastr.clear(toast);
                    toasterService.success("FILE_IMPORTED");
                    return "ok";
                }
            };

            function displayError(validations: $TSFixMe) {
                toasterService.error("MARKET.FILE_HAS_ERRORS");
                const fieldsItems = Object.values(validations)
                    .map((vr: $TSFixMe) =>
                        vr.fieldsErrors
                            .map((e: $TSFixMe) => ({
                                market: vr.marketName,
                                field: e.path,
                                error: e.resultType
                            }))
                            .concat(
                                vr.productsErrors.map((e: $TSFixMe) => ({
                                    market: vr.marketName,
                                    field: e.path,
                                    error: e.resultType,
                                    productCode: e.productCode
                                }))
                            )
                    )
                    .reduce((acc: $TSFixMe, val: $TSFixMe) => acc.concat(val), []);

                service.openFileValidationErrors(fieldsItems);
            }

            service.validateFiles = (market: $TSFixMe) => {
                return $http.post("api/market/file/validate", market).then((response: $TSFixMe) => response.data);
            };

            service.validateVmiProducts = (market: $TSFixMe) => {
                return $http.post("api/vmi/validate-products", market).then((response: $TSFixMe) => response.data);
            };

            service.openFileValidationErrors = (items: $TSFixMe) => {
                var modalInstance = $uibModal.open({
                    size: "lg",
                    component: "fileValidationErrors",
                    resolve: {
                        items: () => items
                    }
                });
                modalInstance.result.then(
                    () => {},
                    () => {}
                );
            };
        }
    ]);
})(angular.module("topline.modules"));
